import { createAction, props } from '@ngrx/store';
import { SaisieInfosSouscripteur } from '../../models/form-state.model';

export const patchInsured = createAction(
  '[Insured Page] Patch Insured Info',
  props<{ payload: Partial<SaisieInfosSouscripteur> }>()
);

export const changeDurationWanted = createAction(
  '[Insured Page] Set Duration Contract',
  props<{ duration: number }>()
);

export const resetInsured = createAction('[Insured Page] Reset Insured Info');

export const changeValidationStatus = createAction(
  '[Insured Page] Change Validation Status',
  props<{ isValid: boolean }>()
);

export const init = createAction('[Init]');
